import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'uploadTooltipMessage',
  standalone: true
})
export class UploadTooltipMessagePipe implements PipeTransform {
  transform(fileExtensions: string, minFileSize: number, maxFileSize: number): string {
    const extensions = fileExtensions?.toUpperCase()?.replace(/./g, '')
    const minSize = minFileSize >= 1024 ? `${(minFileSize / 1024).toFixed(2)}MB` : `${minFileSize.toFixed(0)}KB`
    const maxSize = maxFileSize >= 1024 ? `${(maxFileSize / 1024).toFixed(2)}MB` : `${maxFileSize.toFixed(0)}KB`
    return `${extensions ? `Accepts file types: ${extensions} <br>` : ''}File size: (${minSize} ~ ${maxSize})`
  }
}
